import { CurrencyText, TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import { TrendingUp, TrendingDown } from "lucide-react";
import { ConfidenceLevel } from "@/components/common/svgs/ConfidenceLevel";
import { Link } from "react-router";
import { generateMarketPotentialUrl } from "@/utils/urls";
import { getLocationString } from "@/utils/text";
import { defaultTrailerType } from "@/utils/constants";
import { today } from "@/utils/date";
import { marketToZip } from "@/utils/zips";

export const MarketCard = ({ name, avgRpm, trend, confidence }) => {
    const roundTrend = new Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format(Math.round(trend));

    const pickup = {
        zip: marketToZip[name],
        placeName: name.split(",")[0],
        stateCode: name.split(",")[1],
    };

    const marketPotentialUrl = generateMarketPotentialUrl({
        trailerType: defaultTrailerType,
        pickup: pickup,
        pickupQuery: getLocationString(pickup, false),
        pickupDate: today,
        delivery: null,
        deliveryQuery: "",
    });

    return (
        <Link
            to={marketPotentialUrl}
            className="flex flex-col border border-cm-p-outline rounded-lg pt-[5px] pb-[7px] px-3 w-full lg:w-[215px] cursor-grab"
        >
            <div className="flex items-center justify-between">
                <div className="flex flex-row gap-[6px] items-center">
                    <div>
                        {roundTrend > 0 ? (
                            <TrendingUp className="w-4 h-4 text-cm-p-accent text-base" />
                        ) : (
                            <TrendingDown className="w-4 h-4 text-cm-p-on-container-red text-base" />
                        )}
                    </div>
                    <div
                        className={cn("font-medium text-sm leading-[22px]", {
                            "text-cm-p-accent": roundTrend > 0,
                            "text-cm-p-on-container-red": roundTrend <= 0,
                        })}
                    >
                        {roundTrend}%
                    </div>
                </div>
                {confidence && (
                    <ConfidenceLevel level={confidence === "high" ? 3 : confidence === "medium" ? 2 : 1} />
                )}
            </div>

            <div className="text-sm leading-[22px] text-cm-p-text-primary font-medium">{name}</div>
            <div className="text-sm leading-[22px] text-cm-p-text-secondary">
                <CurrencyText num={avgRpm} className="text-sm leading-[22px] text-cm-p-text-secondary" />{" "}
                <TranslatedText text="avg outbound RPM" />
            </div>
        </Link>
    );
};
